import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { siteUrl } from "@/mocks/siteData";
import HeroSection from "./components/HeroSection";
import WhatIsSection from "./components/WhatIsSection";
import FeaturedResources from "./components/FeaturedResources";
import ComparisonTable from "./components/ComparisonTable";
import WhyUseSection from "./components/WhyUseSection";
import CategoryButtons from "./components/CategoryButtons";
import LatestArticlesSection from "./components/LatestArticlesSection";
import FAQSection from "./components/FAQSection";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "BaseTao Spreadsheet Guide 2026 | Reviews, Shipping, Coupons & Tools",
            "description": "Independent BaseTao Spreadsheet resource hub with guides, reviews, shipping analysis, coupons, and expert tips.",
            "url": `${siteUrl}/`,
            "publisher": {
              "@type": "Organization",
              "name": "BaseTao Sheet",
            },
          })}
        </script>
        <HeroSection />
        <WhatIsSection />
        <FeaturedResources />
        <ComparisonTable />
        <WhyUseSection />
        <CategoryButtons />
        <LatestArticlesSection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}